/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from "react";
import { withRouter } from "react-router-dom";
import { shopContext } from "../../contexts/aniplus";
// import axios from "axios";
//import socketio from 'socket.io-client';
//import $ from 'jquery';
//import socket from 'socket.io-client/lib/socket';

//const socket = socketio.connect('https://socket.aniplustv.com:4100')

class ContentItem extends PureComponent {
  _selectContent = () => {
    const { contentSerial, selectContent, imageLO } = this.props.childProps;
    selectContent(contentSerial, imageLO);
  };

  render() {
    const { selectContentSerial, contentSerial, imageLO } =
      this.props.childProps;
    return (
      <Fragment>
        <li
          className={selectContentSerial === contentSerial ? "active" : ""}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={this._selectContent}
        >
          <img src={imageLO} />
        </li>
      </Fragment>
    );
  }
}
export default shopContext(withRouter(ContentItem));
